import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DeviceService} from '../../../service/devices.service';
import {GroupEnum} from 'src/app/shared/enums/group.enum';
import {MessageService} from 'primeng/api';
import { EquipmentEnterprise } from 'src/app/shared/enums/equipment-enterprise';
import {UserService} from 'src/app/service/user.service';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'real-time-devices-layer',
  templateUrl: './devices-layer.component.html',
  styleUrls: ['./devices-layer.component.scss']
})
export class DevicesLayerComponent implements OnInit, OnChanges {
  @Input() isVisible = true;
  @Input() dark = false;
  activateAnimation = false;

  GroupEnum = GroupEnum;

  styleDisabled = {
    width: '210px',
    height: '60px'
  }

  open: boolean = false;


  styleActived = {
    width: '30%',
    height: '80vh'
  }

  get dataMetrics() {
    return this._dataMetrics;
  }
  @Input()
  set dataMetrics(val: any) {
    this._dataMetrics = val;
    // if(this.dataMetricToGetStatus.length === 0)
    //   this.dataMetricToGetStatus = JSON.parse(JSON.stringify(this._dataMetrics));
  }

  _dataMetrics: any;
  @Output() goToLocation: EventEmitter<any> = new EventEmitter();
  @Output() filteredDevicesChange: EventEmitter<any[]> = new EventEmitter();

  dataMetricsFiltered: any[] = [];
  dataMetricToGetStatus: any[] = [];
  lotes: Array<{ id: string, description: string }> = [];
  selectedLotes: string[] = [];
  devicesLoteMap = new Map<any, string>();

  style = this.styleDisabled;

  timerOut: any;
  filter: any = '';
  activeStatusFilter: 'on' | 'suspended'| 'other' | 'no-pass' | 'total' | 'off' = 'total';

  filterByStatus: any = (d: any) => d;

  constructor(
    private deviceService: DeviceService,
    private messageService: MessageService,
    private userService: UserService,
  ) {}

  // Cada contrato descreve apenas o próprio prazo, sem depender dos demais contratos.
  private readonly profileTooltipByContract: Record<number, () => string> = {
    [GroupEnum.PRF]: () => 'PRF: 5 minutos.',
    [GroupEnum.SANTAMARIA]: () => 'Santa Maria: 48 horas.',
    [GroupEnum.SERRA_GAUCHA]: () => this.generalProfileTooltip(),
    [GroupEnum.ESPIRITO_SANTO]: () => this.generalProfileTooltip(),
    [GroupEnum.VIA_ARAUCARIA]: () => this.generalProfileTooltip(),
    [GroupEnum.BR381]: () => this.generalProfileTooltip(),
  };

  private generalProfileTooltip(): string {
    return environment.production ? 'Produção geral: 2 horas.' : 'Homologação: 48 horas.';
  }

  // Reflete apenas o perfil/prazo do contrato em uso (userService.getCurrentContract), atualizado a cada troca de contrato.
  getActiveProfileTooltip(): string {
    const contract = this.userService.getCurrentContract();
    const contractId = contract?.id;
    const resolveTooltip = contractId != null ? this.profileTooltipByContract[contractId] : undefined;

    if (resolveTooltip) {
      return resolveTooltip();
    }

    const contractLabel = contract?.name ?? (contractId != null ? `id ${contractId}` : 'não identificado');
    return `Prazo indisponível para o contrato atual (${contractLabel}). É necessário configurar o perfil/prazo deste contrato.`;
  }

  getActiveContractName(): string {
    return this.userService.getCurrentContract()?.name ?? 'Não identificado';
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['dataMetrics']) {
      return;
    }

    this.dataMetricsFiltered = changes['dataMetrics']['currentValue']
    this.lotes = this.buildLoteOptions(this.dataMetrics);
    this.devicesLoteMap = this.buildDevicesLoteMap(this.dataMetrics);
    this.selectedLotes = this.selectedLotes.filter(lote =>
      this.lotes.some(option => option.id === String(lote))
    );
    this.applyFilters();
  }

  getStatus() {
    // 0 - off
    // 1 - amarelo - sem passagem
    // 2 - on
    // 3 - suspenso
    // outro - cinza escuro
    const devicesStatus = this.dataMetricToGetStatus.map((d: any) => d.statusOnline) as any[];
    const off = devicesStatus.filter((d: any) => d == 0).length
    const noPass = devicesStatus.filter((d: any) => d == 1).length
    const on = devicesStatus.filter((d: any) => d == 2).length
    const suspended = devicesStatus.filter((d: any) => d == 3).length
    const other = devicesStatus.filter((d: any) => d != 0 && d != 1 && d != 2 && d != 3).length
    const total = devicesStatus.length


    return { off, on, suspended, noPass, other, total }
  }

  setFilterStatus(type: 'on' | 'suspended'| 'other' | 'no-pass' | 'total' | 'off') {
    this.activeStatusFilter = type;

    if(type == 'off') {
      this.filterByStatus = (d: any) => d.statusOnline == 0
    } else if(type == 'no-pass') {
      this.filterByStatus = (d: any) => d.statusOnline == 1
    } else if(type == 'on') {
      this.filterByStatus = (d: any) => d.statusOnline == 2
    } else if(type == 'suspended') {
      this.filterByStatus = (d: any) => d.statusOnline == 3
    } else if(type == 'other') {
      this.filterByStatus = (d: any) => (d.statusOnline != 0 && d.statusOnline != 1 && d.statusOnline != 2 && d.statusOnline != 3);
    }else if(type == 'total') {
      this.filterByStatus = (d: any) => d
    }

    this.applyFilters();
  }



  selectDevice(item: any): void {
    this.goToLocation.emit({ lat: Number(item.latitude), lng: Number(item.longitude) })
  }

  isButtonEnabled(item: any): boolean {
    const statusOnline = item?.statusOnline;
    return !!(item?.equipmentSshPort && statusOnline !== 0);
  }

  getButtonTooltip(item: any): string {
    const enterprise = item?.enterprise?.toLowerCase();

    if (item?.statusOnline === 0) {
      return 'Nao foi possível acessar, equipamento está offline';
    }

    //Mensagem do tooltip deixando apenas a inicial do nome da empresa em maiúsculo caso não seja um equipamento Velsis
    if (enterprise !== EquipmentEnterprise.VELSIS.toLowerCase()) {
      return `Equipamento indisponível para acesso (${enterprise ? enterprise.replace(/^./, (s: string) => s.toUpperCase()) : ''})`;
    }

    if (!item?.equipmentSshPort) {
      return 'Equipamento sem porta de acesso configurada';
    }

    return '';
  }

  goToEquipment(event: any, item: any): void {
    event.stopPropagation();
    if (item?.statusOnline === 0) return;
    if (!item?.equipmentId) return;

    this.deviceService.getDeviceMetricsbyId(item.equipmentId).subscribe({
      next: (data: any) => {
        if (!data?.equipmentUrl || !data?.equipmentInterfacePort) {
          this.messageService.add({
            key: 'toastError',
            severity: 'warn',
            summary: 'Sem acesso',
            detail: 'Dados de acesso indisponíveis',
          });
          return;
        }

        const url = `http://${data.equipmentUrl}:${data.equipmentInterfacePort}/rtm/login`;
        window.open(url, '_blank');
      },
      error: () => {
        this.messageService.add({
          key: 'toastError',
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível buscar os dados de acesso do equipamento',
        });
      }
    });
  }

  orderByLocale(data: any[] = [], applyStatusFilter = true) {
    let formated = Array.from((data ?? []).reduce((devices: Map<string, any>, obj: any) => {
      if (!devices.has(obj.deviceName)) {
        devices.set(obj.deviceName, obj);
      }
      return devices;
    }, new Map<string, any>()).values());

    let sort = formated.sort((a: any, b: any) => {
      const aCase = a.deviceName.toLowerCase();
      const bCase = b.deviceName.toLowerCase();

      return aCase.localeCompare(bCase);
    });

    sort = sort.sort((a: any, b: any) => {
      const isA = a.statusOnline;
      const isB = b.statusOnline;

      if (isA && !isB) {
        return -1;
      } else if (!isA && isB) {
        return 1;
      } else {
        return 0;
      }
    });
    if (applyStatusFilter) {
      formated = formated.filter(this.filterByStatus)
    }
    return formated
  }

  private buildLoteOptions(data: any[] = []) {
    const lotes = new Set(
      (data ?? [])
        .map(device => this.getDeviceLote(device))
        .filter(lote => lote !== '')
    );

    return Array.from(lotes)
      .map(lote => ({
        id: lote,
        description: lote,
      }))
      .sort((a, b) => a.description.localeCompare(b.description, undefined, {numeric: true}));
  }

  private buildDevicesLoteMap(data: any[] = []) {
    const devicesLoteMap = new Map<any, string>();

    (data ?? []).forEach(device => {
      devicesLoteMap.set(this.getDeviceKey(device), this.getDeviceLote(device));
    });

    return devicesLoteMap;
  }

  private getDeviceKey(device: any) {
    return device?.equipmentId ?? device?.deviceId ?? device?.id ?? device?.deviceName;
  }

  private getDeviceLote(device: any): string {
    return device?.lote != null ? String(device.lote) : '';
  }

  loteModelChanges(value: string[]) {
    this.selectedLotes = value ?? [];
    this.applyFilters();
  }

  private applyFilters() {
    const filterValue = this.filter.toLowerCase();
    const selectedLotes = this.selectedLotes.map(lote => String(lote));

    const devicesFilteredBySearchAndLote = this.orderByLocale(this.dataMetrics, false).filter((data: any) => {
      const matchesName = !filterValue
        || (data.deviceName ?? '').toLowerCase().includes(filterValue)
        || (data.streetName ?? '').toLowerCase().includes(filterValue);
      const matchesLote = selectedLotes.length === 0
        || selectedLotes.includes(this.devicesLoteMap.get(this.getDeviceKey(data)) ?? this.getDeviceLote(data));

      return matchesName && matchesLote;
    });

    this.dataMetricToGetStatus = devicesFilteredBySearchAndLote;
    this.dataMetricsFiltered = devicesFilteredBySearchAndLote.filter(this.filterByStatus);
    this.filteredDevicesChange.emit(this.dataMetricsFiltered);
  }

  async search(event: any) {
    if (this.timerOut) {
      clearTimeout(this.timerOut)
    }
    if (event.target.value == '') {
      this.filter = '';
      this.applyFilters();
      return;
    }
    this.timerOut = setTimeout(async () => {
      this.filter = event.target.value
      this.applyFilters();
    }, 1000);
  }


  updateStyle() {
    this.open ? this.style = this.styleDisabled : this.style = this.styleActived
    this.open = !this.open;
    this.activateAnimation = !this.activateAnimation;
  }

}
